import * as actions from '../../actions/expediaActions'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/**
 * @param {Object} params - List of path params
 * @param {number[]} params.organizationIds - Organization Ids
 */
export const expediaPushYearPrices = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.expedia_pushYearPricesRequest())

    securedFetch(urlParams(urls.expediaPushYearPrices, params), auth, { method: 'POST' })
        .then(handleResponse)
        .then(() => dispatch(actions.expedia_pushYearPricesSuccess()))
        .catch(
            handleError(
                dispatch,
                actions.expedia_pushYearPricesFailure,
                'Что-то пошло не так!',
                'При отправке цен в Expedia.com произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params
 * @param {number[]} params.organizationIds - Organization Ids
 */
export const expediaPushYearRestrictions = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.expedia_pushYearRestrictionsRequest())

    securedFetch(urlParams(urls.expediaPushYearRestrictions, params), auth, { method: 'POST' })
        .then(handleResponse)
        .then(() => dispatch(actions.expedia_pushYearRestrictionsSuccess()))
        .catch(
            handleError(
                dispatch,
                actions.expedia_pushYearRestrictionsFailure,
                'Что-то пошло не так!',
                'При отправке ограничений в Expedia.com произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params
 * @param {number} params.organizationIds - Organization Ids
 */
export const expediaPushYearAvailability = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.expedia_pushYearAvailabilityRequest())

    securedFetch(urlParams(urls.expediaPushYearAvailability, params), auth, { method: 'POST' })
        .then(handleResponse)
        .then(() => dispatch(actions.expedia_pushYearAvailabilitySuccess()))
        .catch(handleError(dispatch, actions.expedia_pushYearAvailabilityFailure,
            'Что-то пошло не так!',
            'При отправке доступности в Expedia.com произошла ошибка'))
}

/**
 * @param {Object} params - List of path params (params are optional)
 * @param {number} params.organizationId - Organization Id
 */
export const expediaInventoryAvailability = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.expedia_inventoryAvailabilityRequest())

    securedFetch(urlParams(urls.expediaInventoryAvailability, params), auth, { method: 'POST' })
        .then(handleResponse)
        .then(() => dispatch(actions.expedia_inventoryAvailabilitySuccess()))
        .catch(
            handleError(
                dispatch,
                actions.expedia_inventoryAvailabilityFailure,
                'Что-то пошло не так!',
                'При попытке inventory доступности в Expedia.com произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params (params are optional)
 * @param {number} params.organizationId - Organization Id
 */
export const expediaInventoryOrder = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.expedia_inventoryOrderRequest())

    securedFetch(urlParams(urls.expediaInventoryOrder, params), auth, { method: 'POST' })
        .then(handleResponse)
        .then(() => dispatch(actions.expedia_inventoryOrderSuccess()))
        .catch(
            handleError(
                dispatch,
                actions.expedia_inventoryOrderFailure,
                'Что-то пошло не так!',
                'При попытке inventory заказов Expedia.com произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/expediaApi/expediaSync.js